import { gql } from 'glimmer-apollo';
import { GAME_ARTICLE_FRAGMENT, ESPORTS_ARTICLE_FRAGMENT } from '../fragments/common';

export const GET_HOME_PAGE = gql`
  ${GAME_ARTICLE_FRAGMENT}
  ${ESPORTS_ARTICLE_FRAGMENT}
  
  query HomePageQuery($limit: Int = 9, $offset: Int = 0) {
    homePageEsports: eSportsArticles(limit: $limit, offset: $offset) {
      ...ESportsArticleInfo
    }
    homePageGames: gameArticles(limit: $limit, offset: $offset) {
      ...GameArticleInfo
    }
    gameArticles: gameArticles(limit: 2) {
      ...GameArticleInfo
    }
    esportsArticles: eSportsArticles(limit: 2) {
      ...ESportsArticleInfo
    }
    newsSlider: eSportsArticles(limit: 4) {
      ...ESportsArticleInfo
    }
    popularGameArticles: gameArticles(limit: 2) {
      ...GameArticleInfo
    }
    popularEsportsArticles: eSportsArticles(limit: 2) {
      ...ESportsArticleInfo
    }
  }
`;
